import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { Button } from '../components/ui/button';
import { LogOut, Sun, Moon } from 'lucide-react';
import { ApprovalsModule } from '../components/approvals/ApprovalsModule';
import { ApprovalsBell } from '../components/approvals/ApprovalsBell';

const ManagerDashboard = () => {
  const { user, api, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div className={`min-h-screen ${isDark ? 'bg-[#0a0b0d] text-foreground' : 'bg-[#faf6e7] text-foreground'}`}>
      <header className={`border-b ${isDark ? 'border-[#1e2128] bg-[#0a0b0d]' : 'border-[#e5dfd0] bg-white'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div>
            <h1 className="font-heading text-2xl font-bold">Approvals Dashboard</h1>
            <p className="text-sm text-muted-foreground">Welcome, {user?.name}</p>
          </div>
          <div className="flex items-center gap-2">
            <ApprovalsBell api={api} user={user} />
            <Button variant="ghost" size="icon" onClick={toggleTheme} data-testid="manager-theme-toggle">
              {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            </Button>
            <Button variant="ghost" size="sm" onClick={logout} data-testid="manager-logout-btn">
              <LogOut className="w-4 h-4 mr-1" /> Logout
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-6">
        <ApprovalsModule api={api} user={user} />
      </main>
    </div>
  );
};

export default ManagerDashboard;
